import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";

import { Grid, Typography, Container, Paper, Divider, Icon } from "@mui/material";

import FirmwareTab from 'Modules/manufacturers/.components/firmwareTab';


const FirmwaresReview = (props) => {
    const dispatch = useDispatch();
    const { messages } = useIntl();
    const navigate = useNavigate();


    return (
        <Container maxWidth={false} className="container-view-tab">
            <Paper elevation={0} style={{ overflow: "auto" }}>
                <Grid
                    container
                    direction="row"
                    style={{ padding: "14px 18px", borderBottom: "1px solid #e8e8e8", height: '95vh' }}
                >
                    <Grid item xs={12} style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Typography variant="h6" style={{ fontWeight: 'bold' }}>
                            {messages["vidfleet_firmwares_reviews"]}
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Divider style={{ backgroundColor: '#999999' }} />
                    </Grid>
                    <Grid item xs={12} style={{ marginTop: 10 }}>
                        <FirmwareTab height={window.innerHeight - 200} fromReviewFirmwares />
                    </Grid>
                </Grid>
            </Paper>
        </Container>
    );

};

export default FirmwaresReview;